import { put } from 'utils/api';

export const updateApplication = async ({
  organizationId,
  propertyId,
  applicationId,
  application,
}) => {
  const response = await put(
    `/${organizationId}/${propertyId}/applications/${applicationId}`,
    { client: 'portal', propertyId, ...application },
  );

  if (response.error) {
    return response.error;
  }

  return response;
};
